import React, { useContext, useEffect, useState, createRef } from 'react';
import Navbar from '../../components/navbar';
import Settings from '../../components/settings';
import { ReactComponent as Send } from '../../assets/send.svg';
import './style.scss';
import { UserText, AiText } from '../../components/message';
import { Context } from '../../store';
import axios from 'axios';
import Loader from '../../components/loader';
import io from 'socket.io-client';
import '../../components/message/style.scss';
import { BACKURL, SOCKETURL } from '../../components/network';
import Speech from 'speak-tts';
import Modal from '@material-ui/core/Modal';
let socket;
let token;
const speech = new Speech();
speech
  .init({
    volume: 1,
    lang: 'en-GB',
    rate: 1,
    pitch: 1,
    voice: 'Google UK English Female',
    splitSentences: true,
    // listeners: {
    //   onvoiceschanged: (voices) => {
    //     console.log('Event voiceschanged', voices);
    //   },
    // },
  })
  .then((data) => {
    // console.log('Speech is ready, voices are available', data);
  })
  .catch((e) => {
    console.error('An error occured while initializing : ', e);
  });
const Main = (props) => {
  const { state, dispatch } = useContext(Context);
  const msgRef = createRef();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sound, setSound] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [history, setHistory] = useState([
    {
      id: 0,
      sender: 'ai',
      text: 'Hey Welcome Back!',
      time: new Date().toLocaleTimeString(),
    },
  ]);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const preCheck = async () => {
    if (!localStorage.getItem('copy-user')) {
      props.history.push('/login');
    } else {
      token =
        JSON.parse(localStorage.getItem('copy-user')).token || state.token;
      const data = await axios.post(`${BACKURL}/auth`, { token });
      // const data = await axios.post('http://192.168.0.104:4000/auth', {
      //   token,
      // });
      if (data.data.done) {
        const userData = {
          username: data.data.data.username,
          userImg: data.data.data.userImg,
          token: data.data.token,
          email: data.data.data.email,
        };
        dispatch({
          type: 'USER_LOGIN',
          payload: userData,
        });
        setLoading(true);
      } else {
        localStorage.removeItem('copy-user');
        props.history.push('/login');
      }
    }
  };
  // console.log(2);
  useEffect(() => {
    preCheck();
    handleOpen();
    socket = io(`${SOCKETURL}`, {
      reconnectionDelay: 2500,
    });
    socket.emit('join', { token }, () => {});

    return () => {
      if (socket.connect) socket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    socket.on('message', (message) => {
      const userDiv = document.createElement('div');
      userDiv.innerHTML = `<div class='txt-message user'>
      <div class='txt-des'>
        ${message.message}
        <span>${new Date().toLocaleTimeString()}</span>
      </div>
      <img src=${state.userImg} alt='' 
          id='profile-image' />
    </div>`;
      document.getElementById('display-section').appendChild(userDiv);
      document.getElementById('display-section').scrollBy(0, 100);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    socket.on('ai-message', (message) => {
      const aiDiv = document.createElement('div');
      aiDiv.innerHTML = `<div class='txt-message ai'>
      <img
      id='profile-image'
        src='https://image.freepik.com/free-vector/profile-beautiful-smiling-young-woman-with-flower-her-hair_102172-291.jpg'
        alt='' 
          
      />
      <div class='txt-des'>
        ${message.message}
        <span>${new Date().toLocaleTimeString()}</span>
      </div>
    </div>`;
      document.getElementById('display-section').appendChild(aiDiv);
      document.getElementById('display-section').scrollBy(0, 500);
      if (sound) {
        speech
          .speak({
            text: message.message,
            queue: false,
          })
          .then((data) => {
            console.log('Success !', data);
          })
          .catch((e) => {
            console.error('An error occurred :', e);
          });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const weatherPermission = (msg) => {
    const success = (data) => {
      socket.emit('weather', {
        token,
        message: msg,
        location: {
          lat: data.coords.latitude,
          long: data.coords.longitude,
        },
        userMessage: msg,
      });
    };
    const err = (data) => {
      socket.emit('reply', {
        token,
        message: data.message,
        userMessage: msg,
      });
    };
    navigator.geolocation.getCurrentPosition(success, err);
  };
  const onSend = async (txt) => {
    if (!socket.connect) {
      socket = io(`${SOCKETURL}`, {
        reconnectionDelay: 2500,
      });
      socket.emit('join', { token }, () => {});
    }
    if (msgRef.current.value !== '') {
      if (
        msgRef.current.value.toLowerCase().includes('weather') ||
        msgRef.current.value.toLowerCase().includes('temperature')
      ) {
        return weatherPermission(msgRef.current.value);
      }
      socket.emit('sendMessage', { token, message: txt }, () => {});
    }
  };

  return (
    <div className='main-wrapper'>
      {loading ? (
        <>
          <Navbar props={props} />
          <div className='main-container'>
            <div className='main-side'>
              <Settings props={props} />
            </div>
            <div className='main-box'>
              <div className='message-box'>
                <div className='display-section'>
                  <div className='display-container' id='display-section'>
                    {history.map((i) => {
                      if (i.sender === 'user') {
                        return (
                          <UserText
                            key={Math.random()}
                            text={i.text}
                            time={i.time}
                            userImg={state.userImg}
                          />
                        );
                      }
                      return (
                        <AiText
                          key={Math.random()}
                          text={i.text}
                          time={i.time}
                        />
                      );
                    })}
                  </div>
                </div>
                <div className='txt-section'>
                  <textarea
                    ref={msgRef}
                    id='msg-input'
                    maxLength='100'
                    placeholder='Enter Your Message'
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        if (e.target.value.trim() !== '') {
                          onSend(e.target.value.trim());
                          e.target.value = ''.trim();
                          e.preventDefault();
                        }
                      }
                    }}
                  />
                  <div
                    className='send-btn'
                    onClick={() => {
                      onSend(msgRef.current.value.trim());
                      msgRef.current.value = ''.trim();
                    }}>
                    <Send />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='simple-modal-title'
            aria-describedby='simple-modal-description'>
            <div
              style={{
                width: '80vw',
                maxWidth: '500px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                background: 'white',
                outline: 'none',
                transform: 'translate(-50%,-50%)',
                borderRadius: '20px',
                padding: '20px',
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px 0',
                }}>
                <h2
                  style={{
                    margin: 0,
                  }}>
                  Message
                </h2>
                <button
                  onClick={handleClose}
                  style={{
                    marginLeft: 'auto',
                    display: 'block',
                  }}>
                  X
                </button>
              </div>
              Hello we are still in development so server connection for AI
              maybe slow for the initial message! Please wait for the first
              reply!
              <br />
              Thank You!
            </div>
          </Modal>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Main;
